import { ZodError } from 'zod';

export const getZodErrorMessageForPath = ({
  error,
  path,
}: {
  readonly error?: null | ZodError;
  readonly path: RegExp | string;
}) => {
  const validationError = error?.errors?.length
    ? error?.errors.find((issue) => {
        if (issue.path) {
          if (typeof path === 'string') {
            return issue.path.join('.') === path;
          }

          return path.test(issue.path.join('.'));
        }

        return false;
      })
    : error;

  return validationError?.message ?? null;
};
